import { Component, EventEmitter, Injector, Input, OnInit, Output } from '@angular/core';
import { AppBaseComponent } from '../../app-base.component';
import { firstValueFrom } from 'rxjs';
import { UserDto, UserInputDto, UserService } from '@proxy/users';
import { AutoCompleteCompleteEvent } from 'primeng/autocomplete';

@Component({
    selector: 'app-user-autocomplete',
    templateUrl: './user-autocomplete.component.html',
    standalone: false
})
export class UserAutocompleteComponent extends AppBaseComponent implements OnInit {
  @Input() isRequired: boolean;

  @Output() changeSelectedUser = new EventEmitter<UserDto>();
  users: UserDto[];
  selectedUser: UserDto;
  
  constructor(
    injector: Injector,
    private readonly _userService: UserService
  ) {
    super(injector);
  }

  ngOnInit(): void {
    this.loadUsers();
    this.onChangeSelectedUser();
  }

  async loadUsers(userIdSelected: string = null, filter: AutoCompleteCompleteEvent = null): Promise<void> {
    try {
      this.showLoading();

      const inputDto: UserInputDto = {
        id: userIdSelected,
        filter: filter?.query
      };

      this.users = (await firstValueFrom(this._userService.getAllUsersByInput(inputDto)));
      this.setUserSelectedIfCorrespond();
    } finally {
      this.hideLoading();
    }
  }

  onChangeSelectedUser(): void {
    this.changeSelectedUser.emit(this.selectedUser);
  }

  setUserSelectedIfCorrespond(): void {
    this.selectedUser = this.users.length === 1 ? this.users[0] : undefined;
  }
}
